import React, { useState, useEffect } from 'react';
import FeaturedProjectsCard from './FeaturedProjectsCard';
import ButtonBlue from '../../Buttons/ButtonBlue';
import config from '../../../config';

const FeaturedProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch(`${config.apiUrl}/projects`) 
      .then(response => response.json())
      .then(data => setProjects(data))
      .catch(error => console.error('Error fetching projects', error));
  }, []);

  // Select the first 2 or 3 projects to feature
  const featuredProjects = projects.slice(0, 3);

  return (
    <div className="wrapper-darker">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0% 4%'}}>
        <h2 className="title-blue">Featured Projects</h2>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', width: '100%'}}>
          {featuredProjects.map((project) => (
            <div key={project.id}>
              <FeaturedProjectsCard
                key={project.id}
                photo={`${project.photo}-extra-small.png`}
                title={project.title}
                body={project.body}
              />
            </div>
          ))}
        </div>
        <div className="center">
          <ButtonBlue destination={'/projects'} text={'View More Projects'} />
        </div>
      </div>
    </div>
  );
};

export default FeaturedProjects;